import { Icon } from "@iconify/react";
import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { PATH_DASHBOARD } from "@app/routes/paths";
import { selectGetWishlistProducts } from "@app/modules/wishlist";
import { useEffect } from "react";
import { getWishlist } from "@app/modules/wishlist/slice";

interface WishtlistIconProps {
  onClose?: () => void;
}

const WishtlistIcon = ({ onClose }: WishtlistIconProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const data = useSelector(selectGetWishlistProducts);

  useEffect(() => {
    dispatch(getWishlist({}));
  }, []);

  return (
    <Stack
      position={"relative"}
      onClick={() => {
        navigate(PATH_DASHBOARD.wishlist);
        onClose && onClose();
      }}
    >
      <IconButton>
        <Icon icon={"mdi:heart-outline"} color={theme.palette.primary.main} />
      </IconButton>
      {data?.data?.data?.length !== 0 && (
        <Stack
          sx={{
            position: "absolute",
            cursor: "pointer",
            bottom: 5,
            right: 4,
            height: 16,
            width: 16,
            backgroundColor: theme.palette.common.white,
            border: `1.5px solid ${theme.palette.primary.main}`,
            borderRadius: 50,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ color: theme.palette.primary.main, fontSize: 11 }}>
            {data?.data?.data?.length < 10 ? data?.data?.data?.length : "9+"}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export { WishtlistIcon };
